// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-container.mobile-only-dialog{max-width:900px}@media screen and (max-width:920px){.dialog-container.mobile-only-dialog{max-width:750px}}@media screen and (max-width:820px){.dialog-container.mobile-only-dialog{max-width:650px}}.app-info a{color:var(--primary-color)}.app-info a:hover{color:var(--secondary-color)}", ""]);
// Exports
module.exports = exports;
